<template>
  <div class="flex flex-col w-full items-center justify-center">
    <div v-if="isloading" class="flex flex-col items-center space-y-2 shadow-md p-6 rounded-md">
      <i class="pi pi-spinner-dotted text-green-600 animate-spin text-6xl text-center rounded-full p-5 bg-green-100"></i>
      <p class="text-2xl text-[#061B44] font-bold pt-4">{{ $t('verifying-your-email') }}</p>
      <p class="text-lg text-slate-600 font-normal pb-4 w-96 text-center">{{ $t('please-wait-while-we-verify') }}</p>
    </div>
    <div v-else-if="isVerified" class="flex flex-col items-center space-y-2 shadow-md p-6 rounded-md">
      <i class="pi pi-check-circle text-green-600 text-6xl text-center rounded-full p-5 bg-green-100"></i>
      <p class="text-2xl text-[#061B44] font-bold pt-4">
        {{ $t("email-verified-successfully") }}
      </p>
      <p class="text-lg text-slate-600 font-normal pb-4 w-96 text-center">
        {{ $t('great-your-email-address-has-been') }}
      </p>
      <router-link to="/" class="text-base bg-subDark h-10 flex items-center justify-center px-4 rounded-md text-white font-semibold">{{
        $t("go-to-home-page")
      }}</router-link>
    </div>
    <div v-if="isTokenExpired" class="flex flex-col items-center space-y-2 shadow-md p-6 rounded-md">
      <i class="pi pi-times-circle text-red-600 text-6xl text-center rounded-full p-5 bg-red-100"></i>
      <p class="text-2xl text-[#061B44] font-bold pt-4">{{ $t('verification-link-expired') }}</p>
      <p class="text-lg text-slate-600 font-normal w-96 text-center pb-6">{{ $t('your-verification-token-has-expired') }}</p>
      <button
        @click="requestNewVerificationEmail"
        class="bg-subDark text-white font-semibold py-1 px-12 rounded-lg h-10"
      >
        {{ $t("request-new-verification-email") }}
      </button>
      <p class="text-base text-slate-500 font-normal pb-4 w-96 text-center">{{ $t('didnt-receive-the-email') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "../store/auth";
import {
  API_BASE_URL,
  VERIFYEMAIL,
  RESENDVERIFICATION,
} from "../utils/appConst";
import { onBeforeMount, ref } from "vue";
import { toast } from "vue3-toastify";
import { useI18n } from "vue-i18n";

const verifyEmailUrl = `${API_BASE_URL}${VERIFYEMAIL}`;
const resendVerificationUrl = `${API_BASE_URL}${RESENDVERIFICATION}`;
const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();
const isloading = ref(true);
const isVerified = ref(false);
const isTokenExpired = ref(false);
const { t } = useI18n();

onBeforeMount(() => {
  if (route.query.token) {
    const token = route.query.token.toString();
    checkEmail(token);
  } else {
    router.push({
      name: "Home",
    });
  }
});

const checkEmail = async (token: string) => {
  try {
    const getData = await fetch(verifyEmailUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
      },
      body: JSON.stringify({
        token,
      }),
    });

    if (getData.status === 200) {
      isVerified.value = true;
    } else if (getData.status === 400) {
      isVerified.value = false;
      isTokenExpired.value = true;
    } else {
      isVerified.value = false;
      router.push({
        name: "Home",
      });
    }
    isloading.value = false;
  } catch (error) {
    console.log("check Email:", error);
    isloading.value = false;
  }
};

const requestNewVerificationEmail = async () => {
  try {
    isloading.value = true;
    const response = await fetch(resendVerificationUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
      },
    });

    if (response.status === 200) {
      toast(t("a-new-verification-email-has-been-sent-to-your-email-address"), {
        autoClose: 1500,
        type: "success",
        theme: "light",
      });
    } else {
      toast(
        t("failed-to-send-a-new-verification-email-please-try-again-later"),
        {
          autoClose: 1500,
          type: "error",
          theme: "light",
        }
      );
    }
    isloading.value = false;
  } catch (error) {
    console.log("requestNewVerificationEmail:", error);
    isloading.value = false;
  }
};
</script>
